import script from "./Contato.vue?vue&type=script&setup=true&lang=js"
export * from "./Contato.vue?vue&type=script&setup=true&lang=js"

import "./Contato.css?vue&type=style&index=0&id=0b066f43&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b066f43"]])

export default __exports__